import es from "./translations/es";
import en from "./translations/en";
import fr from "./translations/fr";
import de from "./translations/de";
import it from "./translations/it";
import pt from "./translations/pt";

export default {
  es,
  en,
  fr,
  de,
  it,
  pt
};
